/**
 * WatchlistRemovePopup Component
 *
 * Renders a confirmation popup when removing a company from the watchlist.
 * Shows a confirmation message with Cancel and Remove buttons.
 */

import IconButton, { ICON_BUTTON_TYPES } from '../../../buttons/IconButton';

/**
 * @param {Object} props
 * @param {string} props.companyName - Name of the company being removed
 * @param {Function} props.onClose - Callback to close the popup
 * @param {Function} props.onConfirm - Callback to confirm removal
 */
const WatchlistRemovePopup = ({ companyName, onClose, onConfirm }) => {
  return (
    <>
      <div
        className="add-remove-watchlist-popup-closer"
        role="button"
        tabIndex={0}
        aria-label="Close popup"
        onClick={onClose}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ' || e.key === 'Escape') {
            e.preventDefault();
            onClose();
          }
        }}
      />
      <div className="add-remove-watchlist-popup">
        <div className="title">{`Are you sure you want to remove ${companyName} from watchlist?`}</div>
        <div className="buttons-container">
          <IconButton innerText="Cancel" onClick={onClose} />
          <IconButton
            innerText="Remove from watchlist"
            type={ICON_BUTTON_TYPES.RED}
            filled
            onClick={onConfirm}
          />
        </div>
      </div>
    </>
  );
};

export default WatchlistRemovePopup;
